module.exports = __webpack_public_path__ + "static/headshot-cd4cfd64ef73aa8b470fe6b6234aa342.png";